import { getAsyncData } from "../utils/storeAndRetrieveUtil";
import { get } from "./apiService";
import { getAllTradingAssets } from "./tradingDataService";

export const getTradingAssets = async (type) => {
  try {
    const response = await getAllTradingAssets(type);

    if (response?.data) {
      let assets = response.data;

      if (type) {
        assets = assets.filter((asset) => asset.type === type);
      }

      return {
        ...response,
        data: assets,
      };
    }

    return response;
  } catch (err) {
    throw new Error(err.message);
  }
};
export const getWalletAssets = async (authId) => {
  try {
    const tradingAssets = await get("/api/v1/trading-wallet/get-assets", {
      authId,
    });
    return tradingAssets;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const getAssetsWithChains = async (type) => {
  try {
    const authId = await getAsyncData("authId");
    const params = { authId, type };
    const assetsWithChains = await get(
      "/api/v1/trading-assets/asset-chains",
      params
    );
    return assetsWithChains;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const getTradingAssetChains = async (assetId) => {
  try {
    const { getAllChains } = await import("./tradingDataService");
    const allChains = await getAllChains();

    const filteredChains = allChains.filter(
      (chain) => chain.assetId === assetId
    );

    return {
      status: true,
      data: filteredChains,
    };
  } catch (err) {
    throw new Error(err.message);
  }
};

export const getTradingAssetIconURL = (image) => {
  const iconUrl = window.location.origin + "/images/coins/" + image;
  return iconUrl;
};

export const getStackableAssets = async () => {
  try {
    const response = await getTradingAssets("Crypto");
    if (response?.status && response?.data) {
      const stackableAssets = response?.data?.filter(
        (asset) => asset.canStack === true && asset.status === "Enabled"
      );
      return { success: true, data: stackableAssets };
    }
    return { success: false, data: [] };
  } catch (err) {
    throw new Error(err.message);
  }
};
